import React, { PureComponent } from "react";
import CONSTANTS from "../../../constants";

import { connect } from "react-redux";

import { CheckBox } from "../../Forms/Forms";
import { priceFormat } from "../../../helpers/functions";
const mapStateToProps = (state) => state;

class ForfaitRegularItem extends PureComponent {
  static defaultProps = {
    className: "",
    selectedForfait: "",
    data: {},
    TotalPrice: 0,
  };
  constructor(props) {
    super(props);
    this.state = {
      showItemDetails: false,
      showObligatoryMessage: false,
    };
    this.currencyPlacement = !!Number(window.siteConfig.PoundPlacement);
  }

  render() {
    const forfait = this.props.data;
    const forfaitCatTitle = this.props.forfaitCatTitle;
    const isHappyClass = !!Number(this.props.store.booking.happy)
      ? "form_input service-item__ligne service-item__happy"
      : "form_input service-item__ligne";

    return (
      <React.Fragment>
        {forfaitCatTitle && (
          <h5 className="service-item__category">{forfaitCatTitle} </h5>
        )}
        <div className="service-item__wrapper">
          <div className={`${isHappyClass}`}>
            <CheckBox
              label={forfait.Libelle}
              id={forfait.Items[0].Ref}
              isChecked={forfait.isSelected}
              name={forfait.Items[0].Ref}
              onClick={(e) =>
                this.props.selectThatForfait(
                  e.target.checked,
                  forfait.Items[0].Ref
                )
              }
              customLabelStyle={{
                color:
                  forfait.isSelected && CONSTANTS.SITE_INFO.BRAND_CODE === "C"
                    ? "#57718a"
                    : CONSTANTS.SITE_INFO.BRAND_CODE === "C"
                    ? "#3b3938"
                    : undefined,
              }}
            />
            {!!forfait.Comments.length &&
              CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && (
                <span
                  className="icon__arrow"
                  tabIndex="0"
                  onKeyDown={(e) => {
                    e.key === "Enter" &&
                      (this.state.showItemDetails
                        ? this.setState({ showItemDetails: false })
                        : this.setState({ showItemDetails: true }));
                  }}
                  onClick={() =>
                    this.state.showItemDetails
                      ? this.setState({ showItemDetails: false })
                      : this.setState({ showItemDetails: true })
                  }
                ></span>
              )}

            {CONSTANTS.SITE_INFO.BRAND_CODE === "C" &&
              !!forfait.Comments.length && (
                <div className="iconContainer">
                  <span
                    className={
                      this.state.showItemDetails
                        ? "forfaitIconInfo isClicked"
                        : "forfaitIconInfo"
                    }
                    tabIndex={"0"}
                    onKeyDown={(e) => {
                      e.key === "Enter" &&
                        (this.state.showItemDetails
                          ? this.setState({ showItemDetails: false })
                          : this.setState({ showItemDetails: true }));
                    }}
                    onClick={() =>
                      this.state.showItemDetails
                        ? this.setState({ showItemDetails: false })
                        : this.setState({ showItemDetails: true })
                    }
                  ></span>

                  {this.state.showItemDetails && (
                    <div className="forfaitPopup">
                      {typeof forfait.Comments == "object" &&
                        forfait.Comments.map(function(item, key) {
                          return (
                            <span key={"comment-" + key}>
                              {key + 1} - {item.Text}
                              <br />
                            </span>
                          );
                        })}
                      {typeof forfait.Comments == "string" && (
                        <span>
                          {forfait.Comments} <br />
                        </span>
                      )}
                    </div>
                  )}
                </div>
              )}
          </div>
          <div className="item_price service-item__ligne">
            {!!Number(this.props.store.booking.happy) && (
              <span className="price_discount">
                {priceFormat(forfait.Items[0].Prix) +
                  ` ${CONSTANTS.LABELS.needs_basket_label2}`}
              </span>
            )}
            <span
              className={
                CONSTANTS.SITE_INFO.BRAND_CODE === "C" && forfait.isSelected
                  ? "item_finalPrice selected"
                  : "item_finalPrice"
              }
            >
              {/* {this.currencyPlacement && CONSTANTS.LABELS.common_v2_currency} */}
              {!!Number(this.props.store.booking.happy)
                ? priceFormat(
                    (
                      forfait.Items[0].Prix -
                      forfait.Items[0].Prix *
                        0.01 *
                        this.props.store.booking.happy
                    ).toFixed(2)
                  )
                : priceFormat(forfait.Items[0].Prix)}
              {` ${CONSTANTS.LABELS.needs_basket_label2}`}
            </span>

            {!!Number(this.props.store.booking.happy) && (
              <span className="happy_discount">
                {this.props.store.booking.happy}%
              </span>
            )}
          </div>
          {this.state.showItemDetails &&
            CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && (
              <div className="service-item__details">
                {typeof forfait.Comments == "object" &&
                  forfait.Comments.map(function(item, key) {
                    return (
                      <span key={"comment-" + key}>
                        {key + 1} - {item.Text}
                        <br />
                      </span>
                    );
                  })}
                {typeof forfait.Comments == "string" && (
                  <span>
                    {" "}
                    {forfait.Comments} <br />
                  </span>
                )}
              </div>
            )}
        </div>
      </React.Fragment>
    );
  }
}
export default connect(mapStateToProps)(ForfaitRegularItem);
